import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

const RichText = ({ text, className }) => {
  const richTextRootRef = useRef(null);

  useEffect(() => {
    if (text && richTextRootRef.current) {
      const tables = richTextRootRef.current.querySelectorAll('table');
      tables.forEach(table => {
        const wrapper = document.createElement('div');
        wrapper.className = 'rich-text__table-wrapper';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      });
    }
  }, [text]);

  return !text ? null : (
    <div
      ref={richTextRootRef}
      className={cn('rich-text', className)}
      dangerouslySetInnerHTML={{ __html: text }}
    />
  );
};

RichText.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
};

export default RichText;
